export const PAISES = { BOLIVIA: 1 };